import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import courierVid from "../assets/couriervid.mp4";
import courierLogo from "../assets/courierlog.png";

export default function CourierLogin() {
 const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

  const handleSignIn = async () => {

  if (loading) return;

  try {

    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }

    setLoading(true);

    const response = await API.post(
      "/api/auth/login",
      {
        email,
        password,
      }
    );

    localStorage.setItem(
      "courierToken",
      response.data.token
    );

    localStorage.setItem(
      "courierUser",
      JSON.stringify(response.data.courier)
    );

    localStorage.setItem(
      "courierId",
      response.data.courier.id
    );

    navigate("/courierdashboard");

  } catch (error) {

    alert(
      error.response?.data?.message ||
      "Login failed"
    );

  } finally {

    setLoading(false);

  }

};

  const handleGoogleSignIn = () => {
    alert("Google sign-in successful");
    navigate("/courier");
  };

  return (
<div className="min-h-screen bg-orange-500 py-10 px-4">
  <div className="max-w-md mx-auto">

  {/* TOP INTRO */}
  <div className="text-center mb-8">

    <h1 className="text-3xl font-bold text-white leading-tight">
      Become a courier partner and deliver on your terms.
    </h1>

    <p className="text-white/90 mt-3 text-sm leading-6">
      Choose when you deliver, receive fast payouts,
      and start earning in just a few steps.
    </p>

  </div>
        <div className="bg-orange-400 rounded-2xl p-9 shadow-lg text-center">
        {/* Logo */}
        <div className="mb-5">
          <img
  src={courierLogo}
  alt="Hooks Food Courier"
className="mx-auto w-36 h-36 object-contain mb-2"/>
          <small className="text-white/85 text-xs font-normal">Courier Portal</small>
        </div>

        <h2 className="text-lg font-semibold text-white mb-1 text-center">Welcome Back, Rider</h2>
        <p className="text-sm text-white/90 mb-6">Sign in to start delivering</p>

        {/* Google Sign In */}
        <button
          className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-white/90 text-sm font-semibold text-gray-800 hover:bg-white transition-colors"
          onClick={handleGoogleSignIn}
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="Google"
            className="w-4"
          />
          Continue with Google
        </button>

        <div className="my-4 text-xs text-white/80">OR</div>

        {/* Email */}
        <label className="block text-left text-xs text-white mb-1 mt-3">Email</label>
        <input
          type="email"
          placeholder="rider@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-3 rounded-xl bg-white/30 text-white placeholder-white/75 text-sm outline-none"
        />

        {/* Password */}
        <label className="block text-left text-xs text-white mb-1 mt-3">Password</label>
        <input
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-3 rounded-xl bg-white/30 text-white placeholder-white/75 text-sm outline-none"
        />

        {/* Sign in */}
<button
  disabled={loading}
  onClick={handleSignIn}
  className={`w-full mt-5 py-3 rounded-xl text-white text-sm font-semibold transition-colors ${
    loading
      ? "bg-orange-300 cursor-not-allowed"
      : "bg-orange-500 hover:bg-orange-600"
  }`}
>
  {loading ? "Signing in..." : "Sign in"}
</button>
        {/* Footer */}
        <div className="mt-5 flex justify-between text-xs text-white/85">
          <span
            className="cursor-pointer font-semibold hover:underline"
            onClick={() => navigate("/courierforgetpassword")}
          >
            Forgot password?
          </span>
          <span>
            New courier?{" "}
            <b
              className="cursor-pointer font-semibold hover:underline"
              onClick={() => navigate("/couriercreateaccount")}
            >
              Join now
            </b>
          </span>
        </div>
      </div>

      {/* VIDEO */}
<div className="mt-2 rounded-2xl overflow-hidden shadow-2xl">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full rounded-2xl"
        >
          <source
            src={courierVid}
            type="video/mp4"
          />
        </video>

      </div>

      {/* BOTTOM INFO */}
      <div className="mt-8 text-center">

        <h2 className="text-2xl font-bold text-white">
          Trusted by 3.5+ million courier partners worldwide
        </h2>

        <p className="text-white/90 mt-3 leading-7 text-sm">
          Hooks Food connects courier partners to
          thousands of daily orders from trusted local
          restaurants in your city.
        </p>

      </div>

    </div>
  </div>
);
}
